import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./WaitingForPayment.module.css";
import useAuthGuard from "../../../hooks/useAuthGuard";

const WaitingForPayment = () => {
  useAuthGuard();
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/payment-success");
    }, 5000);
  }, [navigate]);

  return (
    <div className={styles.container}>
      <h2>Processing Your Payment...</h2>
      <p>Please wait while we verify your transaction.</p>
      <div className={styles.loader}></div>
    </div>
  );
};

export default WaitingForPayment;
